import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "@fortawesome/fontawesome-free/js/all";
import "./includes/bootstrap";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./configs/theme";
import App from "./App";
import "./index.css";
import configureStore from "./store/configureStore";
import {mobileAndTabletCheck} from './utils/utils';
import DesktopApp from './desktop/DesktopApp';
import {v4 as uuidv4} from 'uuid';
import CacheBuster from './CacheBuster';
// import { PARENT_WEBSITE } from "./desktop/site-config/CrossSiteConfigs";

let deviceIdLocal = localStorage.getItem('deviceid');
if (!deviceIdLocal) {
  let uuid = uuidv4();
  if (typeof uuid != 'undefined' && uuid && uuid.length > 0) {
    localStorage.setItem("deviceid",uuid.replace(/-/g,''));
  }
}
// if (typeof document !== 'undefined') {
//   document.addEventListener("DOMContentLoaded", function(event) { 
//     if (typeof window !== 'undefined' && typeof window.xdLocalStorage !== 'undefined') {
//       window.xdLocalStorage.init(
//         {
//             iframeUrl:PARENT_WEBSITE()?PARENT_WEBSITE():'',
//             initCallback: function () {
//                 console.log('Got iframe ready');
//                 window.xdLocalStorage.setItem('check', 'no callback');
//             }
//         }
//       );
//     }
//   });
// }
const store = configureStore();
const TransportBook = ()=>{
  return (
    <CacheBuster>
        {({ loading, isLatestVersion, refreshCacheAndReload }) => {
          if (loading) return null;
          if (!loading && !isLatestVersion) {
            refreshCacheAndReload();
          }
          return (
            <Provider store={store}>
              <BrowserRouter>
                <ThemeProvider theme={theme}>
                  <CssBaseline />
                  {mobileAndTabletCheck() && <App /> }
                  {!mobileAndTabletCheck() && <DesktopApp /> }
                </ThemeProvider>
              </BrowserRouter>
            </Provider>
          );
        }}
      </CacheBuster>
  )
}
ReactDOM.render(
  <TransportBook />,
  document.querySelector("#root")
);
